module.exports = __webpack_public_path__ + "img/69.4.NH3-N.1678ea75.png";